import React from "react"
import Layout from "../components/layout"
import { MainContainer } from "../styles/commonComponents"
import styled from "styled-components"
import Login from "../components/login/login"
import LoginFooterImage from "../images/login-footer.png"

const ContextBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row; 
        align-items: flex-start; 
        margin: 4rem 0 0 0;
    }
`

const MessageBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media (min-width: 768px) {
        width: 50%;  
        padding: 0 1rem  0 2rem; 
    }
    @media (min-width: 768px) {
        width: 55%;  
        padding: 0 1rem  0 1rem; 
    }
`

const GreetingsBox = styled.div`
    font-size: 2.4rem;
    font-weight: 500;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 2.4rem 0 0 0;
    padding: 0 1.2rem;
    @media (min-width: 768px) {
        margin: 4rem 0 0 0; 
        font-size: 2.8rem;
    }
`

const GreetingsText = styled.div`
    font-size: 1.6rem;
    font-weight: 400;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 2.4rem 1.2rem 0 1.2rem;
`

const LoginBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: -1rem 0 0 0;
    @media (min-width: 768px) {
        width: 50%;   
        margin: 0 0 0 0;
        padding: 0 1rem 0 0;
    }
    @media (min-width: 1280px) {
        width: 45%;   
        margin: 0 0 0 0;
        padding: 0 1rem 0 0;
    }
`

const ImageBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: 4rem 0 4rem 0;

`

const Image = styled.img`
    width: 100%;
    display: block;
`

const LoginPage = (props) => {
    return (
        <Layout {...props} backgroundColor={"#FFF"}>
            <MainContainer style={{ maxWidth: "120rem" }}>
                <ContextBox>
                    <MessageBox>
                        <GreetingsBox>Welcome to ACE Hardware Philippines B2B</GreetingsBox>
                        <GreetingsText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit vitae leo nec sollicitudin. Nulla facilisi.</GreetingsText>
                    </MessageBox>
                    <LoginBox>
                        <Login />
                    </LoginBox>
                </ContextBox>
                <ImageBox><Image src={LoginFooterImage} /></ImageBox>

            </MainContainer>
        </Layout>
    )
}

export default LoginPage